import DictionaryEntryList from './DictionaryEntryList';

export default DictionaryEntryList;
